import(/* webpackMode: "eager" */ "/home/runner/work/tipsy-ui/tipsy-ui/app/[lang]/@desktop/(app)/(default)/_components/DesktopHomePage.tsx");
